export default __webpack_public_path__ + "static/media/cooking-big-pizza_72229-259@2x.b8f8955c.png";